import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import PurchaseRecapActions from "../../../../reducers/modules/purchasing/purchase-recap/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "purchasing/purchaserecap";

export default class PurchaseRecapMiddleware {
  static create(params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.create());
      PurchaseRecapMiddleware.showHelperFull(dispatch, params);
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.update());
      //PurchaseRecapMiddleware.showHelperFull(dispatch, params);
      PurchaseRecapMiddleware.showDetail(dispatch, params);
      //PurchaseRecapMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.process());
      PurchaseRecapMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.reset());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.view());
      PurchaseRecapMiddleware.showOne(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.resetList());
    };
  }
  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.submit());
      PurchaseRecapMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.submit());
      PurchaseRecapMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.delete());
      PurchaseRecapMiddleware.delete(dispatch, params, id);
    };
  }
  static beforeConvert(id, search) {
    const post = {
      date: id,
    };
    return (dispatch) => {
      dispatch(PurchaseRecapActions.convert());
      PurchaseRecapMiddleware.saveConvert(dispatch, post, search);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static getHelper(params = null) {
    return (dispatch) => {
      PurchaseRecapMiddleware.showHelperFull(dispatch, params);
    };
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      PurchaseRecapMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getDetail(params) {
    return (dispatch) => {
      dispatch(PurchaseRecapActions.view());
      PurchaseRecapMiddleware.showDetail(dispatch, params);
    };
  }

  static showDetail(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url + "/" + "detail" + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRecapActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchaserecap-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRecapActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveConvert(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url + "/add-po",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRecapActions.process(),
            PurchaseRecapMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRecapActions.success());
          PurchaseRecapMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Convert Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchaserecap-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRecapActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRecapActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRecapActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRecapActions.process(),
            PurchaseRecapMiddleware.showlist(dispatch, params)
          );
          PurchaseRecapMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRecapActions.process(),
            PurchaseRecapMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRecapActions.success());
          PurchaseRecapMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${PurchaseRecapMiddleware.getToken()}`,
      },
      url: url + "/" + "update",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRecapActions.process(),
            PurchaseRecapMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRecapActions.success());
          PurchaseRecapMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRecapMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PurchaseRecapActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        // dispatch(BranchActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
